/*
  Single place the app talks to the backend from.

  Every request goes through this axios instance, so the base URL lives in
  one spot (overridable at build time via REACT_APP_API_URL) and the session
  token is attached at request time - reading it when the call happens, not
  when a module first loads.
*/
import axios from 'axios';

export const BASE_URL =
  process.env.REACT_APP_API_URL || 'https://test-pm1-backend-service.azurewebsites.net';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('session_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setSessionToken(token) {
  sessionStorage.setItem('session_token', token);
}

export function getSessionToken() {
  return sessionStorage.getItem('session_token');
}

export function clearSession() {
  sessionStorage.removeItem('session_token');
}

export default api;
